import { render, staticRenderFns } from "./BetgameEditDescription.vue?vue&type=template&id=535b33df&scoped=true"
import script from "./BetgameEditDescription.vue?vue&type=script&lang=js"
export * from "./BetgameEditDescription.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditDescription.vue?vue&type=style&index=0&id=535b33df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535b33df",
  null
  
)

export default component.exports